import { connection } from '@vp/vue-components';

export const useConnectionStore = connection.useConnectionStore;
